// ColorConfigPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import DynamicTable from '../components/DynamicTable';
import ColorConfigModal from '../components/ColorConfigModal';
import TopBar from '../components/TopBar';
import TitleBackButton from '../components/TitleBackButton';

import {
  get_colorconfig,
  update_colorconfig,
} from '../api/api';

const ColorConfigPage = () => {
  const { item_id } = useParams();
  const [page, setPage] = useState(1);
  const [colorConfigs, setColorConfigs] = useState([]);
  const [colorConfigData, setColorConfigData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
  const updateModalRef = useRef();

  const updateGrid = async () => {
    try {
      const res = await get_colorconfig();
      const data = res?.data?.results || [];
      console.log(data);
      setColorConfigs(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    updateGrid();
  }, []);

  const openAndResetUpdateModal = (data) => {
    setColorConfigData(data);
    setUpdateModalOpen(true);
    setTimeout(() => {
      updateModalRef.current?.setup(data);
    }, 0);
  };


  const colorRenderer = (params) => {
            const color = params.value;
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  width: '16px',
                  height: '16px',
                  backgroundColor: color,
                  border: '1px solid #ccc',
                  borderRadius: '3px'
                }} />
                <span>{color}</span>
              </div>
            );
          };

  const getColumnDefs = () => [
    { field: 'table_title', headerName: 'Titolo Tabella', flex: 1 },
    { field: 'legend_title', headerName: 'Titolo Legenda', flex: 1 },
    {
          field: "scoutastic_color",
          headerName: "Colore Scoutastic",
          width: 150,
          cellRenderer: colorRenderer
    },
    {
          field: "pdf_color",
          headerName: "Colore PDF",
          width: 150,
          cellRenderer: colorRenderer
    },
    {
          field: "b_tier",
          headerName: "Leghe inferiori",
          width: 150,
    },
    {
          field: "order",
          headerName: "Ordinamento",
          width: 150,
    },
  ];

  const editCallback = async (id) => {
    const res = await get_colorconfig();
    if (res?.data?.results) {
      const match = res.data.results.find((c) => c.id === id);
      if (match) {
        openAndResetUpdateModal(match);
      }
    }
  };

  return (
    <div>
      <TopBar />
      <div className="content">
        <div className="main-content">
          <div className="dynamic-table-topbar-right">
            <TitleBackButton title="Configurazione Colori" />
          </div>

          <div className="dynamic-table-outer">
            <DynamicTable
              items={colorConfigs}
              getColumnDefs={getColumnDefs}
              showDownloadButtons={false}
              updateGrid={updateGrid}
              editCallback={editCallback}
              preventDelete={true}
            />

            <ColorConfigModal
              ref={updateModalRef}
              colorConfigData={colorConfigData}
              isOpen={isUpdateModalOpen}
              onClose={() => {
                updateGrid();
                setUpdateModalOpen(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorConfigPage;
